// src/utils/imageOptimizer.ts
import imageCompression from 'browser-image-compression';

export async function compressImage(file: File): Promise<File> {
  // Configuration for balancing quality vs size
  const options = {
    maxSizeMB: 0.3,          // Max size 300KB (Huge egress saving)
    maxWidthOrHeight: 1920,  // Max dimension (Full HD is enough for cars)
    useWebWorker: true,      // Don't freeze the UI
    fileType: 'image/webp',  // WebP is superior to JPG/PNG
    initialQuality: 0.8,     // Good quality start point
  };

  try {
    console.log(`Original size: ${(file.size / 1024 / 1024).toFixed(2)} MB`);
    
    const compressedFile = await imageCompression(file, options);
    
    console.log(`Compressed size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);

    // Create a new File object with the .webp extension
    const newFileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
    
    return new File([compressedFile], newFileName, {
      type: 'image/webp',
      lastModified: new Date().getTime(),
    });
  } catch (error) {
    console.error("Image compression failed, falling back to original:", error);
    return file; // Fail safe: return original if compression breaks
  }
}